import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { AssessmentRow } from "@/lib/database.types";

// All assessments for a patient, newest first. A patient can have both a
// 'wl' and a 'trt' assessment (cross-pathway), and even multiple of each
// over time if they re-submit; consumers typically pick the latest per type.
export function useAssessments(patientId: string | undefined) {
  return useQuery<AssessmentRow[]>({
    queryKey: ["assessments", patientId],
    enabled: !!patientId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("assessments")
        .select("*")
        .eq("patient_id", patientId!)
        .order("submitted_at", { ascending: false });
      if (error) throw error;
      return (data as AssessmentRow[] | null) ?? [];
    },
  });
}
